/**
 * @fileoverview Recognizes a refused mutation that needs a refresh-and-review, not a retry.
 * @description The Sales CRM commands are optimistic: each sends the version the user reviewed
 * (`If-Match` for a prospect, `X-Approval-Version` for a review request). A `412` (stale version)
 * or `409` (state or routing changed) means the record moved on since the dialog loaded it, so the
 * UI must show the latest state before the user decides again — never resend blindly (3.5.11.0).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { ApiException } from '@/shared/api/api.exception'

/**
 * @description Whether a mutation failed because the record changed after it was read.
 * @param {unknown} error - The mutation's error.
 * @returns {boolean} True for a `412` or `409` response.
 */
export function isStaleVersionError(error: unknown): boolean {
  return error instanceof ApiException && (error.status === 412 || error.status === 409)
}
